/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { ResumeMonitorMutationResponse, ResumeMonitorPathParams, ResumeMonitor401, ResumeMonitor404 } from '../types/ResumeMonitor.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getResumeMonitorUrl(id: ResumeMonitorPathParams['id']) {
  const res = { method: 'POST', url: `/v1/monitors/${id}/resume` as const };
  return res;
}

/**
 * @summary Resume a paused monitor
 * {@link /v1/monitors/:id/resume}
 */
export async function resumeMonitor(id: ResumeMonitorPathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<ResumeMonitorMutationResponse, ResponseErrorConfig<ResumeMonitor401 | ResumeMonitor404>, unknown>({
    method: 'POST',
    url: getResumeMonitorUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
